import type { ReactNode } from "react";
import { createContext, useContext } from "react";

const DisplayTimeZoneContext = createContext<string>("UTC");

export function DisplayTimeZoneProvider({
  timeZone,
  children,
}: {
  timeZone: string;
  children: ReactNode;
}) {
  return (
    <DisplayTimeZoneContext.Provider value={timeZone}>
      {children}
    </DisplayTimeZoneContext.Provider>
  );
}

export function useDisplayTimeZone(): string {
  return useContext(DisplayTimeZoneContext);
}
